import { Paginated } from '../api';
import { Localizable } from '../localization';

import { QuestionnaireBlueprint } from '@zinnia/form-engine-sdk';

type QuestionnaireVersionComputedProps = {
  applicationsCount: string;
};

export type QuestionnaireVersionInfo = {
  id: string;
  questionnaireId: string;
  createdAt: Date;
  updatedAt: Date;
  majorVersion: number;
  minorVersion: number;
  description?: string | null;
  isDraft: boolean;
  questionnaireName?: Localizable<string>;
} & QuestionnaireVersionComputedProps;

export type QuestionnaireVersionRowData = Omit<QuestionnaireVersionInfo, 'majorVersion' | 'minorVersion'> & {
  version: string;
};

export type QuestionnaireVersionInfoPage = Paginated<QuestionnaireVersionInfo>;

export type QuestionnaireVersionDetail = {
  id: string;
  blueprint: QuestionnaireBlueprint;
  questionnaireId: string;
  dataStructure: [string, unknown][];
  isDraft: boolean;
  isLatestVersion: boolean;
  majorVersion: number;
  minorVersion: number;
  description?: string;
  questionnaireName?: Localizable<string>;
  flags?: QuestionnaireVersionFlag[];
};

export enum QuestionnaireVersionFlag {
  AuraNextMedicalInterview = 'AuraNextMedicalInterview',
}
